(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jewel-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jewel-customer-reviews')) {
    class JewelCustomerReviews extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-jcr-list]');
        this.reviews = Array.from(this.querySelectorAll('[data-jcr-review]'));
        this.sort = this.querySelector('[data-jcr-sort]');
        this.pagination = this.querySelector('[data-jcr-pagination]');
        this.pageNumbers = this.querySelector('[data-jcr-page-numbers]');
        this.paginationStatus = this.querySelector('[data-jcr-pagination-status]');
        this.pageSize = 5;
        this.currentPage = 1;
        this.orderedReviews = [...this.reviews];

        this.sort?.addEventListener('change', () => {
          this.currentPage = 1;
          this.update();
        });
        this.pagination?.addEventListener('click', (event) => this.changePage(event));
        this.querySelectorAll('[data-jcr-vote]').forEach((button) => this.setupVote(button));
        this.update();
      }

      update() {
        const sortValue = this.sort?.value || 'recent';
        this.orderedReviews = [...this.reviews].sort((first, second) => {
          if (sortValue === 'media') {
            return Number(second.dataset.hasMedia) - Number(first.dataset.hasMedia) || Number(first.dataset.index) - Number(second.dataset.index);
          }
          if (sortValue === 'high') {
            return Number(second.dataset.rating) - Number(first.dataset.rating) || Number(first.dataset.index) - Number(second.dataset.index);
          }
          if (sortValue === 'low') {
            return Number(first.dataset.rating) - Number(second.dataset.rating) || Number(first.dataset.index) - Number(second.dataset.index);
          }
          return Number(first.dataset.index) - Number(second.dataset.index);
        });

        this.orderedReviews.forEach((review) => {
          this.list.appendChild(review);
        });
        this.renderPage(false);
      }

      changePage(event) {
        const button = event.target.closest('button[data-jcr-page], button[data-jcr-page-action]');
        if (!button || button.disabled) return;

        const totalPages = Math.max(1, Math.ceil(this.orderedReviews.length / this.pageSize));
        if (button.dataset.jcrPage) {
          this.currentPage = Number(button.dataset.jcrPage);
        } else if (button.dataset.jcrPageAction === 'previous') {
          this.currentPage -= 1;
        } else if (button.dataset.jcrPageAction === 'next') {
          this.currentPage += 1;
        }

        this.currentPage = Math.min(Math.max(this.currentPage, 1), totalPages);
        this.renderPage(true);
      }

      renderPage(shouldScroll) {
        const totalPages = Math.max(1, Math.ceil(this.orderedReviews.length / this.pageSize));
        this.currentPage = Math.min(Math.max(this.currentPage, 1), totalPages);
        const firstVisibleIndex = (this.currentPage - 1) * this.pageSize;
        const lastVisibleIndex = firstVisibleIndex + this.pageSize;

        this.orderedReviews.forEach((review, index) => {
          review.hidden = index < firstVisibleIndex || index >= lastVisibleIndex;
        });

        if (this.pagination) {
          this.pagination.hidden = totalPages <= 1;
          this.renderPageNumbers(totalPages);

          const previous = this.pagination.querySelector('[data-jcr-page-action="previous"]');
          const next = this.pagination.querySelector('[data-jcr-page-action="next"]');
          if (previous) previous.disabled = this.currentPage === 1;
          if (next) next.disabled = this.currentPage === totalPages;
        }

        const pageLabel = this.pagination?.dataset.pageLabel || 'Page';
        if (this.paginationStatus) {
          this.paginationStatus.textContent = totalPages > 1 ? `${pageLabel} ${this.currentPage} / ${totalPages}` : '';
        }

        if (shouldScroll && this.list) {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.list.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        }
      }

      renderPageNumbers(totalPages) {
        if (!this.pageNumbers) return;
        this.pageNumbers.replaceChildren();
        const visiblePages = [];

        for (let page = 1; page <= totalPages; page += 1) {
          if (page === 1 || page === totalPages || Math.abs(page - this.currentPage) <= 1) {
            visiblePages.push(page);
          }
        }

        visiblePages.forEach((page, index) => {
          const previousPage = visiblePages[index - 1];
          if (previousPage && page - previousPage > 1) {
            const ellipsis = document.createElement('span');
            ellipsis.className = 'jcr__page-ellipsis';
            ellipsis.textContent = '…';
            ellipsis.setAttribute('aria-hidden', 'true');
            this.pageNumbers.appendChild(ellipsis);
          }

          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'jcr__page-number';
          button.dataset.jcrPage = String(page);
          button.textContent = String(page);
          button.setAttribute('aria-label', `${this.pagination?.dataset.pageLabel || 'Page'} ${page}`);
          if (page === this.currentPage) button.setAttribute('aria-current', 'page');
          this.pageNumbers.appendChild(button);
        });
      }

      setupVote(button) {
        const sectionId = this.dataset.sectionId;
        const reviewId = button.dataset.reviewId;
        const direction = button.dataset.jcrVote;
        const baseCount = Number(button.dataset.baseCount || 0);
        const count = button.querySelector('[data-jcr-count]');
        const storageKey = `jcr:${sectionId}:${reviewId}`;
        let savedVote = null;

        try {
          savedVote = window.localStorage.getItem(storageKey);
        } catch (error) {
          savedVote = null;
        }

        const refresh = () => {
          let currentVote = null;
          try {
            currentVote = window.localStorage.getItem(storageKey);
          } catch (error) {
            currentVote = null;
          }
          const active = currentVote === direction;
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
          if (count) count.textContent = String(baseCount + (active ? 1 : 0));
        };

        refresh();
        button.addEventListener('click', () => {
          try {
            const currentVote = window.localStorage.getItem(storageKey);
            window.localStorage.setItem(storageKey, currentVote === direction ? '' : direction);
          } catch (error) {
            savedVote = savedVote === direction ? '' : direction;
          }
          this.querySelectorAll(`[data-review-id="${reviewId}"]`).forEach((voteButton) => {
            const voteDirection = voteButton.dataset.jcrVote;
            const voteBase = Number(voteButton.dataset.baseCount || 0);
            let currentVote = savedVote;
            try {
              currentVote = window.localStorage.getItem(storageKey);
            } catch (error) {
              currentVote = savedVote;
            }
            const active = currentVote === voteDirection;
            voteButton.setAttribute('aria-pressed', active ? 'true' : 'false');
            const voteCount = voteButton.querySelector('[data-jcr-count]');
            if (voteCount) voteCount.textContent = String(voteBase + (active ? 1 : 0));
          });
        });
      }
    }

    customElements.define('jewel-customer-reviews', JewelCustomerReviews);
  }

  } catch(e) { console.error(e); }
})();
})();
